import React from 'react';
import PropTypes from 'prop-types';
import {Heatmap} from 'buildingos-charts';
import Card from 'common/components/card';
import CardHeader from 'common/components/card-header';
import CardContent from 'common/components/card-content';
import {parseInitialRanges} from 'common/components/range-color-picker';
import SvgSymbol from 'common/components/svg-symbol';
import {ReportLegendColorsEnum} from 'common/proxies/enum-proxy';
import {getGroupsForHeatmap} from 'common/utils/chart-util';
import {t} from 'common/utils/translation-util';

import colorScales from './colors';

export default class HeatMapCard extends React.Component {
  static propTypes = {
    appUrl: PropTypes.string,
    connectDragSource: PropTypes.func,
    disableConfig: PropTypes.bool,
    report: PropTypes.object.isRequired,
  };

  getAvailableAnaylticsApps() {
    // FIXME Don't reference settings on window directly.
    // Settings should be part of application context,
    // or at least, passed as props.
    if (window && window.settings && window.settings.availableAnalyticsApps) {
      return window.settings.availableAnalyticsApps;
    }
    return null;
  }

  getCustomConfigOptions(availableAnalyticsApps, appUrl) {
    if (availableAnalyticsApps && availableAnalyticsApps.heatmap) {
      return [
        <a
          href={appUrl}
          key={'HeatMapCard-custom-config-option--appUrl'}
          rel={'noopener noreferrer'}
          target={'_blank'}>
          <SvgSymbol name={'export'} />
          {t('Open in Heat Map app')}
        </a>,
      ];
    }
    return [];
  }

  render() {
    const {appUrl, connectDragSource, disableConfig, report} = this.props;
    const {id, meta, name, priorityWarnings, warnings} = report;
    const {dataManagerUrl, legendColorScale, legendCustomColors, period} = meta;
    const groups = getGroupsForHeatmap(report);
    const availableAnalyticsApps = this.getAvailableAnaylticsApps();
    const customConfigOptions = this.getCustomConfigOptions(
      availableAnalyticsApps,
      appUrl,
    );
    const colors =
      colorScales[
        legendColorScale?.id || ReportLegendColorsEnum.GREEN_YELLOW_RED.id
      ];

    const customColorRanges = parseInitialRanges(legendCustomColors);

    return (
      <Card className={'HeatMapCard'} loading={false}>
        {(connectDragSource || ((x) => x))(
          <div>
            <CardHeader
              customConfigOptions={customConfigOptions}
              dataManagerUrl={dataManagerUrl}
              disableConfig={disableConfig}
              priorityWarnings={priorityWarnings}
              reportId={id}
              subtitle={period.displayName}
              title={name}
              warnings={warnings}
            />
          </div>,
        )}
        <CardContent className={'HeatMapCard--content'}>
          <div>
            <Heatmap
              colors={colors}
              customColorRanges={customColorRanges}
              groups={groups}
              gutters={30}
              noDataMessage={t('No data')}
            />
          </div>
        </CardContent>
      </Card>
    );
  }
}
